var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-empty",style:({'marginLeft': _vm.window.menuIndentContent})},[_c('i',{staticClass:"fa-solid fa-face-frown-slight"}),(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }